import React, { Component } from "react";
import { Formik, Form } from "formik";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import LightBox from "../../../ui/LightBox";
import { setListing, updateListing, sendNewListingEmail } from "../actions";
import { generateFileUrl } from "../../../../apiHelper";
import { getUserProfileInfo } from "../../../user/actions";
import ExportCalComponent from "../export-calendar-modal";
import { PAGE_ROUTES } from "../../../../constants/pageRoutes";
import { pushSuccess } from "../../../global/actions";
import { MAGIC_NUMBER } from "../../../../constants/magicNumbers";
import ShowSuccessToasts from "../../../global/successToast";
import ShowErrorToasts from "../../../global/errorToast";

const mapStateToProps = (state) => ({
  listing: state.Listing,
  user: state.User.user,
});

export const canOwnerCreateListing = (user, history, dispatch) => {
  const message =
    "Please complete your profile before you access this functionality.";

  const redirectTo = "/dashboard/manage-listings";
  if (!user || !user.profile || !user.profile.photo) {
    dispatch(pushSuccess(message));
    setTimeout(() => {
      history.push(`${PAGE_ROUTES.OWNER_SIGN_UP_3}?redirect=${redirectTo}`);
    }, MAGIC_NUMBER.REDIRECT_DELAY);
    return false;
  }

  if (!user.accounts || !user.accounts.length) {
    dispatch(pushSuccess(message));
    history.push(`${PAGE_ROUTES.OWNER_SIGN_UP_2}?redirect=${redirectTo}`);
    setTimeout(() => {}, MAGIC_NUMBER.REDIRECT_DELAY);
    return false;
  }

  return true;
};

class ListingFormPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      galleryImages: [],
      isSaving: false,
      isPublishing: false,
      ExportCalModalOpen: false,
      isCompletingProfile: false,
    };

    this.openExportCalModal = this.openExportCalModal.bind(this);
    this.closeExportCalModal = this.closeExportCalModal.bind(this);
  }

  componentDidMount() {
    let { dispatch } = this.props;
    dispatch(getUserProfileInfo(this.props.listing.listingData.userId));
  }

  getLightBoxImages = () => {
    let images = [];
    let id = this.props.listing.listingData._id;
    let listingData = this.props.listing.listingData.photos;
    if (listingData && listingData.length > 0) {
      listingData.map((x) => {
        images.push({
          src: !!this.props.listing.listingData.streamId
            ? x
            : generateFileUrl(x, id),
          height: 4,
          width: 8,
        });
      });
    }
    return images;
  };

  openExportCalModal() {
    this.setState({ ExportCalModalOpen: true });
  }
  closeExportCalModal() {
    this.props.history.push(`/${this.props.parent}/manage-listings`);
  }

  onSubmit = (values, { setSubmitting }) => {
    if (this.state.isCompletingProfile) return;

    const { user, dispatch, listing } = this.props;

    if (!canOwnerCreateListing(user, this.props.history, dispatch)) {
      this.setState({
        isCompletingProfile: true,
      });
      return;
    }

    this.setState({ isPublishing: true });
    listing.listingData.isActive = true;
    listing.listingData.lastCompleted = null;
    dispatch(setListing(listing.listingData));
    this.openExportCalModal();
    setTimeout(() => {
      dispatch(updateListing());
      dispatch(sendNewListingEmail(user));
      setSubmitting(false);
    }, 1000);
  };

  save = () => {
    this.setState({ isSaving: true });
    let { dispatch, listing } = this.props;
    listing.listingData.lastCompleted = null;
    dispatch(setListing(listing.listingData));
    this.openExportCalModal();
    setTimeout(() => {
      dispatch(updateListing());
    }, 1000);
  };

  renderExportCalModal(listingData) {
    return (
      <ExportCalComponent
        onSubmit={this.closeExportCalModal}
        onClose={this.closeExportCalModal}
        listingData={listingData}
      />
    );
  }

  publish = (updatedData) => {
    this.setState({ isPublishing: true });
    updatedData.isActive = true;
    this.props.dispatch(setListing(updatedData));
    this.props.dispatch(updateListing());
  };

  render() {
    let listingData = this.props.listing.listingData;
    let images = this.getLightBoxImages();
    let defaultImage = images.length > 0 ? images[0].src : "";

    return (
      <div>
        <ShowSuccessToasts />
        <ShowErrorToasts />
        {this.state.ExportCalModalOpen &&
          this.renderExportCalModal(this.props.listing.listingData)}
        <Formik onSubmit={this.onSubmit}>
          {({ setFieldValue, handleSubmit }) => (
            <Form>
              <div className="button-row row">
                <div className="col">
                  {this.state.isSaving ? (
                    <button
                      className="btn-secondary float-left"
                      disabled={true}
                      onClick={() => {}}
                    >
                      Saving...
                    </button>
                  ) : (
                    <button
                      className="btn-secondary float-left"
                      disabled={this.state.isPublishing}
                      type="button"
                      onClick={this.save}
                    >
                      Save
                    </button>
                  )}
                </div>
                <div className="col">
                  {this.state.isPublishing ? (
                    <button
                      className="btn-primary float-right"
                      disabled={true}
                      onClick={() => {}}
                    >
                      Publishing...
                    </button>
                  ) : (
                    <button
                      className="btn-primary float-right"
                      disabled={this.state.isSaving}
                      onClick={() => {
                        setFieldValue("buttonClicked", "publish");
                        handleSubmit();
                      }}
                    >
                      Publish
                    </button>
                  )}
                </div>
              </div>
              <div className="listing-preview">
                <div className="description-heading">
                  Your listing is ready! Please review the information below.
                  Click Publish to make your listing available to
                  CollegeWeekends.com renters. Click Save if you would like to
                  publish later.
                </div>
                <section>
                  <LightBox defaultImage={defaultImage} images={images} />
                </section>
                <section className="listing-details">
                  <span className="marker">
                    <i className="fas fa-map-marker-alt"></i>{" "}
                    {listingData.address.city}, {listingData.address.state}
                  </span>
                  <h2>{listingData.listingName}</h2>
                  <span className="listing-type">{listingData.houseType}</span>
                  <div className="listing-specs">
                    {listingData.bedrooms} bedrooms | {listingData.bathrooms}{" "}
                    bathrooms | sleeps {listingData.sleeps}
                  </div>
                </section>
                <section className="listing-price">
                  <span className="price-bold">
                    ${listingData.pricing.baseFee}
                  </span>{" "}
                  average/night
                </section>
                <section className="listing-about">
                  <h5>About the Property</h5>
                  <p>{listingData.listingDetails.about}</p>
                </section>
                <section className="listing-information">
                  <div>
                    <h5>Sleeping Arrangements</h5>
                    <p>{listingData.listingDetails.sleepingArrangements}</p>
                  </div>
                  <div className="mb-3">
                    <h5>Amenities</h5>
                    {listingData.amenities.map((name, index) => {
                      return <li key={index}>{name}</li>;
                    })}
                  </div>
                  <div className="mb-3">
                    <h5>Host Rules</h5>
                    {listingData.listingDetails.petsAllowed ? (
                      <li>Pets Allowed</li>
                    ) : (
                      <li>No Pets Allowed</li>
                    )}
                    {listingData.listingDetails.smokingAllowed ? (
                      <li>Smoking Allowed</li>
                    ) : (
                      <li>No Smoking Allowed</li>
                    )}
                  </div>
                </section>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default withRouter(connect(mapStateToProps)(ListingFormPreview));
